import citizenactivity2 from "../../../assets/CampuLifeImages/citizenactivity2.jpg"
import citizenactivity3 from "../../../assets/CampuLifeImages/citizenactivity3.jpg"
import citizenactivity1 from "../../../assets/CampuLifeImages/citizenactivity1.jpg"
import citizenactivity4 from "../../../assets/CampuLifeImages/citizenactivity4..jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import citizenbanner from "../../../assets/CampuLifeImages/citizenbanner.jpg"
const CitizenConsumer = () => {
 
    const data = 
    { 
      name:"citizenconsumer",
            pagename: "Citizen Consumer Club", 
      viewmore:"true",
      viewless:"true",
      hover:true,
      title: "Citizen Consumer Club Activities",
      contentImg:citizenbanner,
      para:"The Citizen Consumer Club (CCC) was introduced as an initiative by the Department of Civil Supplies and Consumer Protection to create awareness among young consumers about their rights and responsibilities. The concept gained momentum in India in the early 2000s, with various states promoting the establishment of CCCs in schools and colleges. The objective was to equip students with knowledge about consumer laws, ethical purchasing, and grievance redressal mechanisms. A Citizen Consumer Club in NICAS is a student organization focused on raising awareness about consumer rights, responsibilities, and consumer protection.",
      paranext:"The initiative was initially supported by consumer rights activists, educational institutions, and legal experts who played a key role in shaping its activities. Over time, CCCs have expanded across the country, engaging thousands of students in Consumer Awareness Programmes, Legal Literacy Campaigns, and Advocacy Efforts.",
      paraonetitle:"Vision :",
      paraone:"To create a community of informed and responsible consumers who should be  aware of their rights and duties, capable of making ethical choices, and actively involved in promoting consumer protection for a fair and transparent marketplace.",
      title2:"Motto :",
      subtitle2:"“NOT ME BUT YOU”, reflects the value of democratic living and upholds the need for selfless service.",
      subtitle3:"Mission :",
      subtitlecontent3:"To empower students by fostering consumer awareness, educating them about their rights and responsibilities, and promoting knowledge of product quality and standards.",
      fourhover:true
    }
   
   const hoverContent =[
     {  img: citizenactivity1, para1: "Inaugural of Consumer Awareness Programme", para2: "October 26, 2023" },
     {  img: citizenactivity2, para1: "Speech on Consumer Awareness Programme", para2: "July 19, 2024" },
     {  img: citizenactivity3, para1: "Department of Business Administration organizes Millet Food Festival", para2: "August 13, 2024" },
     {  img: citizenactivity4, para1: "Honouring Chief Guest in Millet Food Festival", para2: "August 13, 2024" }
 ]


 const tableData = [
  {title:"Citizen Consumer Club Organizers"},
  {headings:[{heading1:"S.No",heading2:"Name",heading3:"Designation & Department",heading4:"Position"}]},
  {data:[{ id: 1, name: 'Snanuja S. S.', designDept:"---" ,pos:"President"},
  { id: 2, name: 'N. Adhitya', designDept:"---" ,pos:"VicePresident" },
  { id: 3, name: 'Irish Sugan Breeze E. R.', designDept:"---" ,pos:"Secretary" },
  { id: 4, name: 'M. Hassin Jesra', designDept:"---" ,pos:"Joint Secretary" },
  { id: 5, name: 'K. Ragul Karthick', designDept:"---" ,pos:"Treasurer" },
  { id: 6, name: 'MRS.  P. INDIRA', designDept:"Assistant Professor, Business Administration" ,pos:"Coordinator" },
  { id: 7, name: 'MRS.  N. SHEEJA', designDept:"Assistant Professor, Commerce" ,pos:"Member" },
  { id: 8, name: 'MRS.  C. SHEEBA CHRISTILDA', designDept:"Assistant Professor, Business Administration" ,pos:"Member" }
]},
  {padding:true}
];
  return (
    <>
    <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    </>
  )
}

export default CitizenConsumer